let selectEnvs = {}
if (!(process.env.ICO_ENV === 'prod' || process.env.ICO_ENV === 'hrd')) {
  selectEnvs.aws = require('./env_aws')
  selectEnvs.ciq = require('./env_ciq')
  selectEnvs.ddq = require('./env_ddq')
  selectEnvs.dev = require('./env_dev')
  selectEnvs.dlq = require('./env_dlq')
  selectEnvs.gnr = require('./env_gnr')
  selectEnvs.grq = require('./env_grq')
  selectEnvs.hrd = require('./env_hrd')
  selectEnvs.hrdw = require('./env_hrdw')
  selectEnvs.irq = require('./env_irq')
  selectEnvs.local = require('./env_local')
  selectEnvs.mcq = require('./env_mcq')
  selectEnvs.nru = require('./env_nru')
  selectEnvs.qa = require('./env_qa')
}

function getEnvironment(env = null) {
  let environment = {}
  if (process.env.ICO_ENV === 'prod' || process.env.ICO_ENV === 'hrd') {
    // single environment build configurations, no selection
    // Put atomic equalities here if you dont want to expose all environments.
    environment = require('./env_' + process.env.ICO_ENV) //this works only because env vars will be const
  } else {
    if (!env) env = process.env.ICO_ENV
    environment = selectEnvs[env]
    if (!environment) environment = require('./env_dev')
  }

  if (environment.environmentName === 'staging') {
    const queryParams = getQueryParametersFromUrl()
    const cfBranchId = queryParams && queryParams['cfbranchid']
    if (cfBranchId && validateBranchId(cfBranchId)) {
      // override funnelWebComponentUrl
      const cfStack = queryParams['cfstack']
      const cfBranchStack = cfStack ? `${cfBranchId}/${cfStack}` : cfBranchId
      environment.funnelWebComponentUrl = `https://ui.awskbbicodevnp.kbb.com/ico-components-funnel/${cfBranchStack}/ico-components-funnel/ico-components-funnel.esm.js`
    }
  }

  return environment
}

function getQueryParametersFromUrl() {
  try {
    const search = window.location.search
    const params = new URLSearchParams(search)
    let paramObj = {}
    for (var value of params.keys()) {
      paramObj[value] = params.get(value)
    }
    return paramObj
  } catch {
    return {}
  }
}

function validateBranchId(str) {
  // Regular expression pattern for case-insensitive matching
  const pattern = /^us\d{7}$/i
  // Test the string against the pattern
  if (pattern.test(str)) {
    return true
  } else {
    return false
  }
}

module.exports = { getEnvironment, selectEnvs }
